// Detects headless render-worker mode. The webserver launches a headless
// browser at `/?render_worker=<service-token>`; in that mode the SPA does not
// mount the normal UI — it authenticates with the token and drives report
// render jobs (see runRenderWorker).

/** The service token from a `?render_worker=` query, or null when not in worker
 *  mode (absent or empty). */
export function getRenderWorkerToken(search: string): string | null {
  const token = new URLSearchParams(search).get("render_worker");
  return token && token.length > 0 ? token : null;
}
